<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <TabNav :links="routesNav" @action="onNavAction" />
    </div>

    <div class="container-body">

        <section class="info-card temp-password-card" v-if="!generatedPassword">
            <h3 class="info-card__title">Crear contraseña temporal</h3>

            <p class="temp-password-lead">
                Se generará una contraseña nueva para {{ userFullname }}.
            </p>

            <ul class="temp-password-consequences">
                <li>Su contraseña actual deja de servir de inmediato.</li>
                <li>Deberá crear una propia en el próximo inicio de sesión.</li>
                <li>La contraseña se muestra <strong>una sola vez</strong>: hay que entregársela en ese momento.</li>
            </ul>

            <div class="temp-password-actions">
                <button class="btn btn-danger" v-on:click="generateTempPassword()" :disabled="submitting">
                    {{ submitting ? 'Generando...' : 'Generar contraseña temporal' }}
                </button>
                <button class="btn btn-secondary" v-on:click="onClickGoBack()" :disabled="submitting">Cancelar</button>
            </div>
        </section>

        <section class="info-card temp-password-card" v-else>
            <h3 class="info-card__title">Contraseña temporal creada</h3>

            <p class="temp-password-lead">
                Entrégasela a {{ userFullname }}. No se va a volver a mostrar.
            </p>

            <div class="temp-password-row">
                <code class="temp-password-code">{{ generatedPassword }}</code>
                <button class="btn btn-secondary" v-on:click="copyToClipboard()">Copiar</button>
            </div>

            <ul class="temp-password-consequences">
                <li>La contraseña anterior quedó invalidada.</li>
                <li>Al iniciar sesión, el sistema le pedirá crear una propia.</li>
            </ul>

            <div class="temp-password-actions">
                <button class="btn btn-secondary" v-on:click="onClickGoBack()">Volver a la ficha</button>
            </div>
        </section>

    </div>

    <UserDeleteModal
      v-if="showDeleteModal"
      :userId="$route.params.idUser"
      :userName="deleteModalUserName"
      @close="closeDeleteModal"
      @deleted="onUserDeleted"
    />

</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'

import {restUser} from '@/components/mixin/restUser.js'
import { userDeleteModal } from '@/components/mixin/userDeleteModal.js'

export default{
    name: 'users-temp-password',
    mixins: [restUser, userDeleteModal],
    data(){
        return{
            generatedPassword: '',
            submitting: false
        }
    },
    components:{
        Breadcrumb,
        TabNav
    },
    computed: {
        userFullname: function(){
          const fullname = ((this.user.firstname || '') + ' ' + (this.user.lastname || '')).trim()
          return fullname || 'este usuario'
        },
        routesNav: function(){
          return [
                {name:'Resumen' , path: '/usuarios/' + this.$route.params.idUser, exact: true},
                {name:'Editar usuario' , path: '/usuarios/' + this.$route.params.idUser + '/editar-usuario'},
                {name:'Asignar mapas' , path: '/usuarios/' + this.$route.params.idUser + '/asignar-mapas'},
                {name:'Crear contraseña temporal' , path: '/usuarios/' + this.$route.params.idUser + '/contrasena-temporal'},
                {name:'Historial de cambios' , path: '/usuarios/' + this.$route.params.idUser + '/historial-de-cambios'},
                {name:'Eliminar usuario' , action: 'delete'}
              ]
        },
        routesBread: function(){
          return [
              {name:'Usuarios', path: '/usuarios' },
              {name: this.user.firstname + ' ' + this.user.lastname, path: '/usuarios/' + this.$route.params.idUser},
              {name: 'Contraseña temporal'}
              ]
        }
    },
    props: [],
    methods:{
        onClickGoBack: function() {
            this.$router.push('/usuarios/' + this.$route.params.idUser)
        },
        generateTempPassword: function() {
            var that = this;
            that.submitting = true;
            this.$http.post(this.$store.getters.backendurl + 'api/v1/users/' + this.$route.params.idUser + '/temp-password')
            .then(function (response) {
                that.generatedPassword = response.data.password;
                that.submitting = false;
            })
            .catch(function (error) {
                console.log(error)
                that.submitting = false;
                var msg = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Error al crear contraseña temporal';
                that.$store.dispatch('toast/show', { message: msg, type: 'error' });
            });
        },
        // navigator.clipboard solo existe en contextos seguros (HTTPS o localhost).
        // Sobre HTTP quedaba undefined y `navigator.clipboard.writeText` lanzaba un
        // TypeError sincrónico, así que el .catch nunca se enganchaba y el botón
        // fallaba sin decir nada (QA-76). Se comprueba antes y se cae a execCommand,
        // que sí funciona sobre HTTP.
        copyToClipboard: function() {
            var that = this;
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(this.generatedPassword)
                .then(function () {
                    that.$store.dispatch('toast/show', { message: 'Contraseña copiada', type: 'info' });
                })
                .catch(function () {
                    that.copyWithFallback();
                });
                return;
            }
            this.copyWithFallback();
        },
        copyWithFallback: function() {
            var area = document.createElement('textarea');
            area.value = this.generatedPassword;
            area.setAttribute('readonly', '');
            area.style.position = 'fixed';
            area.style.top = '0';
            area.style.opacity = '0';
            document.body.appendChild(area);
            area.select();

            var copied = false;
            try {
                copied = document.execCommand('copy');
            } catch (e) {
                copied = false;
            }
            document.body.removeChild(area);

            if (copied) {
                this.$store.dispatch('toast/show', { message: 'Contraseña copiada', type: 'info' });
            } else {
                this.$store.dispatch('toast/show', {
                    message: 'No se pudo copiar automáticamente. Selecciónala y cópiala a mano.',
                    type: 'warning'
                });
            }
        }
    },
    created () {
        this.$store.getters.getPermissions.users? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getUser();
    }
}
</script>

<style lang="scss" scoped>
.temp-password-card {
    max-width: 44rem;
    margin: 0 auto;
}

.temp-password-lead {
    margin: 0 0 1rem;
    font-size: 0.95rem;
    color: var(--color-graphite);
}

.temp-password-row {
    display: flex;
    gap: 0.75rem;
    align-items: center;
    padding: 0.85rem 1rem;
    margin-bottom: 1.1rem;
    background: var(--color-mist);
    border: 1px solid var(--color-line);
    border-radius: 6px;
}

.temp-password-code {
    flex: 1;
    font-size: 1.15rem;
    letter-spacing: 0.06em;
    font-family: monospace;
    color: var(--color-navy);
    word-break: break-all;
    user-select: all;
}

.temp-password-consequences {
    margin: 0 0 1.3rem;
    padding-left: 1.1rem;

    li {
        font-size: 0.88rem;
        line-height: 1.55;
        color: var(--color-graphite);
        padding: 0.15rem 0;
    }
}

.temp-password-actions {
    display: flex;
    gap: 0.75rem;
}
</style>
